<template>
  <div class="home">
    <topmenu @refresh="refreshHandle" @add="addModalShow = true"/>
    <section class="section">
      <div class="container">
        <div class="last-day">
          <b-tabs v-model="activeTab">
            <b-tab-item label="Процес">
              <b-field label="Пошук">
                <b-input @input="searchQuery"></b-input>
              </b-field>
              <div v-if="tdProc && tdProc.length > 0">
                <h4 class="subtitle is-4">Сегодня</h4>
                <procTable @refresh="refreshHandle" :data="tdProc" @showSelected="activeTab = 1" @setSelected="selected = $event"/>
              </div>
              <div class="pdt-2" v-if="data && data.length > 0">
                <h4 class="subtitle is-4">Прошлые дни</h4>
                <procTable @refresh="refreshHandle" :data="data" @showSelected="activeTab = 1" @setSelected="selected = $event"/>
              </div>


              <costs :data="waste" @refresh="getCostsHandle"/>

            </b-tab-item>

            <b-tab-item label="Інформація по картці">
              <selectedCard @removed="refreshAfterRemoved" :selected="selected" :services="services"/>
            </b-tab-item>
          </b-tabs>
        </div>
      </div>
    </section>

    <div class="add-fixed-button">
      <b-button type="is-info" @click="addModalShow = true" icon-left="plus" />
    </div>

    <addPanel
      v-if="addModalShow"
      @refresh="refreshHandle"
      @close="addModalShow = false"
    />

  </div>
</template>

<script>
// @ is an alias to /src
import topmenu from "@/components/menu.vue";
import costs from "@/components/costs.vue";
import procTable from "@/components/procTable.vue";
import addPanel from "@/components/fixedBottomPanel.vue";
import selectedCard from "@/components/selectedCard.vue";
import { mapActions, mapState } from 'vuex';

export default {
  name: "home",
  data() {
    return {
      addModalShow: false,
      ndProc: null,
      tdProc: null,
      waste: [],
      selected: null,
      activeTab: 0,
      query: ''
    };
  },
  computed: {
    ...mapState(['services']),
    today() {
      var today = new Date();
      var dd = today.getDate();
      var mm = today.getMonth() + 1; //January is 0!
      var yyyy = today.getFullYear();
      return `${yyyy}-${mm}-${dd}`
    },
    data() {
      return this.ndProc || []
    }
  },
  methods: {
    ...mapActions(['getCosts', 'getProcesses', 'getCards', 'editProcesses']),
    refreshAfterRemoved() {
      this.activeTab = 0
      this.refreshHandle()
    },
    searchQuery(query) {
      this.query = query
      this.notDoneProcesses()
      this.todayProcesses()
    },
    cartMask(number) {
      const length = 4 - String(number).length
      let str = ''
      for (let index = 0; index < length; index++) {
        str = str + '0'
      }
      return str + String(number)
    },
    async refreshHandle() {
      await this.getCostsHandle()
      await this.todayProcesses()
      await this.notDoneProcesses()
    },
    findProgram(x, v) {
      let find = this.services.find(({id}) => id == x)
      if (find && v == 'name') return find.name
      if (find && v == 'price') return find.price
      return find || null
    },
    async getCostsHandle() {
      const res = await this.getCosts({
        date: this.today
      })
      this.waste = res
    },
    price(row) {
      return Number(row.rounded_weight) * this.findProgram(row.service_id, 'price')
    },
    toPay(x, type) {
      this.editProcesses({
        point: `processes/${x.id}/pay/${type}`
      }).then(res => console.log(res))
    },
    async notDoneProcesses() {
      await this.getProcesses({
        params: {
          not_done: true,
          not_paid: true,
          search: this.query
        }
      }).then(res => {
        this.ndProc = res
      })
    },
    async todayProcesses() {
      await this.getProcesses({
        params: {
          date: this.today,
          search: this.query
        }
      }).then(res => this.tdProc = res.filter(({status}) => status != 2))
    }
  },
  components: {
    topmenu,
    procTable,
    addPanel,
    selectedCard,
    costs
  },
  mounted() {
    this.refreshHandle()
  }
};
</script>
